import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import logo from "../images/logo.png"

import './index.css'

const Header = () => (
    <div
        style={{
            background: '#686868',
            minHeight: '100vh',
            display: 'flex',
        }}
    >
        <div
            style={{
                margin: 'auto',
                maxWidth: 960,
                padding: '1.45rem 1.0875rem',
                textAlign: 'center',
                color: '#aebb8f',
            }}
        >
            <h1 style={{margin: 0}}>
                <Link
                    to="/"
                    style={{
                        color: '#aebb90',
                        textDecoration: 'none',
                    }}
                >
                </Link>
            </h1>
            <img src={logo} alt="Logo"/>
            <h2>New Website coming soon.</h2>
            <h4>For all enquiries: <a
                href={'mailto:enquiries@cotswoldcabinetry.com'}>enquiries@cotswoldcabinetry.com</a></h4>
        </div>
    </div>
)

const TemplateWrapper = ({children}) => (
    <div>
        <Helmet
            title="Cotswold Cabinetry"
            meta={[
                {name: 'description', content: 'Sample'},
                {name: 'keywords', content: 'sample, something'},
            ]}
        />
        <Header/>
        {/*<div*/}
        {/*style={{*/}
        {/*margin: '0 auto',*/}
        {/*maxWidth: 960,*/}
        {/*padding: '0px 1.0875rem 1.45rem',*/}
        {/*paddingTop: 0,*/}
        {/*}}*/}
        {/*>*/}
        {/*{children()}*/}
        {/*</div>*/}
    </div>
)

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js